
import API_END_POINTS from "../../utilities/Constants/ApiEndpoints";
import { baseApi } from "./baseQuery";

const workBenchPageAPI = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getWorkBenchData: build.query({
            query: (secret_key) => ({
                url: `${API_END_POINTS.VIEWPORT_VIEW_DRAFT_MODEL}/?secret_key=${secret_key}`,
                method: "GET",
            }),
        }),
        generateModel: build.mutation({
            query: ({ values, queryParam }) => ({
                url: `${API_END_POINTS.VIEWPORT_DATA}?key=${queryParam ? queryParam : ""}`,
                method: "POST",
                body: values
            }),
        }),
        draftModel: build.mutation({
            query: ({ values, queryParam }) => ({
                url: `${API_END_POINTS.VIEWPORT_DATA_DRAFT}?key=${queryParam ? queryParam : ""}`,
                method: "POST",
                body: values
            }),
        }),
        getViewportGeneratedModelList: build.query({
            query: (value) => ({
                url: `${API_END_POINTS.VIEWPORT_GENERATED_MODELS_LIST}?format_type=${value.format_type}&search=${value.search}&page=${value.page}&perPage=${value.perPage}`,
                method: "GET",
            }),
        }),
        getViewportDraftModelList: build.query({
            query: (value) => ({
                url: `${API_END_POINTS.VIEWPORT_DRAFT_MODELS_LIST}?format_type=${value.format_type}&search=${value.search}&page=${value.page}&perPage=${value.perPage}`,
                method: "GET",
            }),
        }),
        linkGeneratedModelList: build.query({
            query: (values) => ({
                url: API_END_POINTS?.MODELS_LIST + `?listType=${values.listType}&showAll=${values.showAll}&search=${values?.search}`,
                method: "GET",
            }),
            providesTags: ["workbench"]
        }),
        getNodes: build.query({
            query: (value) => ({
                url: API_END_POINTS?.GET_NODES_DATA + `/?secret_key=${value}`,
                method: "GET",
            }),
            providesTags: ["workbench"]
        }),
        getEdges: build.query({
            query: (value) => ({
                url: API_END_POINTS?.GET_EDGES_DATA + `/?secret_key=${value}`,
                method: "GET",
            }),
            providesTags: ["workbench"]
        }),
        getLinkModelsList: build.query({
            query: (value) => ({
                url: API_END_POINTS?.VIEW_PORT_MODEL_LIST + `?search=${value?.search}`,
                method: "GET",
            }),
            providesTags: ["workbench"]
        }),
        generateContextData: build.mutation({
            query: (value) => ({
                url: API_END_POINTS?.CONTEX_MODEL,
                method: "POST",
                body: value
            }),
            invalidatesTags: ["workbench"]
        }),
        OnboardSingleStaff: build.mutation({
            query: (value) => ({
                url: API_END_POINTS?.ONBOARD_SINGLE_STAFF,
                method: "POST",
                body: value
            }),
        }),

        getWorkBenchPermissions: build.query({
            query: (value) => ({
                url: API_END_POINTS.GET_WORKBENCH_PERMISION + `?secret_key=${value}`
            })
        }),
        staffShareModels: build.mutation({
            query: (value) => ({
                url: API_END_POINTS?.STAFF_SHARE_MODELS,
                method: "POST",
                body: value
            }),
        }),

        updateUserPermision: build.mutation({
            query: (value) => ({
                url: API_END_POINTS?.UPDATE_USER_PERMISSION + `?secret_key=${value?.secret_key}&email=${value?.email}&new_permission=${value?.workbench_permission}`,
                method: "PUT",
            })
        }),

        workBenchPermisionList: build.query({
            query:() => ({
                url: API_END_POINTS.WORKBENCH_PERMISTION_LIST,
            })
        }),
        getColorGradient: build.query({
            query: (value) => ({
                url: API_END_POINTS.GET_COLOR_GRADIENT + `?secret_key=${value}`,
            })
        }),
        updateColorGradient: build.mutation({
            query: (value) => ({
                url: API_END_POINTS.UPDATE_COLOR_GRADIENT + `?secret_key=${value?.secret_key}`,
                method: "POST",
                body: value?.data
            }),
            invalidatesTags: ["workbench"]
        }),
        getStaffEmailList: build.query({
            query: (value) => ({
                url: API_END_POINTS?.STAFF_EMAIL_LIST + `/?search=${value}`,
                method: "GET",
            }),
            providesTags: ["workbench"]
        }),
    }),
    // @ts-ignore
    overrideExisting: module.hot?.status() === "apply",
});

export const {
    useLazyGetWorkBenchDataQuery,
    useGenerateModelMutation,
    useDraftModelMutation,
    useLazyGetViewportGeneratedModelListQuery,
    useLazyGetViewportDraftModelListQuery,
    useLinkGeneratedModelListQuery,
    useGetNodesQuery,
    useGetEdgesQuery,
    useGetLinkModelsListQuery,
    useGenerateContextDataMutation,
    useOnboardSingleStaffMutation,
    useGetWorkBenchPermissionsQuery,
    useStaffShareModelsMutation,
    useUpdateUserPermisionMutation,
    useWorkBenchPermisionListQuery,
    useGetColorGradientQuery,
    useUpdateColorGradientMutation,
    useGetStaffEmailListQuery
} = workBenchPageAPI;
